import React from 'react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  size?: 'md' | 'lg';
};
export function CtaButton({
  children,
  href = '#oferta',
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-10 py-4 text-sm md:text-base' : 'px-6 py-3 text-xs';
  const isExternal = href.startsWith('http');
  return <a href={href} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`cta-shine relative isolate inline-flex items-center justify-center overflow-hidden rounded-lg border border-gold/60 bg-[#152a5e] font-display font-bold uppercase tracking-[0.08em] text-cream shadow-[0_0_38px_-6px_rgba(37,73,150,0.9)] transition-[transform,background-color] duration-150 ease-out hover:bg-[#1b3673] hover:-translate-y-0.5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-soft ${sizing} ${className}`} data-id="element-210" data-mp="20w56r03ulnrx">
      <span className="relative z-10" data-id="element-211" data-mp="187hh6sc2gc8k">{children}</span>
    </a>;
}